import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent } from 'vue';

// Dynamic imports using defineAsyncComponent
interface Props {
  product: Record<string, any>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-private-lounge-details',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: Record<string, any>;
};

const IconPlane = defineAsyncComponent(() => import('@white-label-icon/icon-plane'));
const IconBaggage = defineAsyncComponent(() => import('@white-label-icon/icon-baggage'));
const IconCabinBaggage = defineAsyncComponent(() => import('@white-label-icon/icon-cabin-baggage'));
const IconRestaurant = defineAsyncComponent(() => import('@white-label-icon/icon-restaurant'));

// Props definition


// Reactive data
const baggageTypes = {
  checked_baggage: {
    icon: IconBaggage,
    text: 'privateLoungeFeatures.baggage.checked_baggage',
  },
  cabin_baggage: {
    icon: IconCabinBaggage,
    text: 'privateLoungeFeatures.baggage.cabin_baggage',
  },
};

// Computed
const details = computed(() => props.product?.details);

return { __sfc: true,IconPlane, IconBaggage, IconCabinBaggage, IconRestaurant, props, baggageTypes, details }
}

})